import React from 'react';
import { Tab, Logo, TicketLink } from '../styles/city-tab.style';

/**
 * Title Component
 * @param {object} props Incoming props
 * @returns {XML} A title component
 */
const CityTab = ({
  cityAbbreviation,
  cityName,
  teamLogo,
  teamName,
  teamTabBackground,
  isActive,
  select,
  expanded,
  mobile,
  minimized,
  ticketSelector,
  ticketMasterLink,
  stadiumName,
}) => {
  const contentfulBgUrl = teamTabBackground && teamTabBackground.file && teamTabBackground.file.url;
  const contentfulLogoUrl = teamLogo && teamLogo.file && teamLogo.file.url;
  const background = contentfulBgUrl || '/images/Team-BG_300x348.png';
  let layout;

  if (contentfulLogoUrl) {
    layout = (
      <div className="wrapper">
        { (!minimized || !expanded) && <Logo className="team-logo" logo={contentfulLogoUrl} />}
        <h3 className="city-name">
          { cityName }
        </h3>
        {teamName && (!minimized || !expanded) ? <h3 className="team-name">{teamName}</h3> : '' }
      </div>
    );
  } else {
    layout = (
      <div>
        {(!minimized || !expanded) && <div className="abbreviation">{cityAbbreviation}</div>}
        <h3 className="city-name">
          {((!minimized || !expanded) && stadiumName) || cityName}
        </h3>
      </div>
    );
  }

  return ticketSelector && ticketMasterLink ? (
    <TicketLink
      href={ticketMasterLink}
      rel="noopener noreferrer"
      target="_blank"
      className={`
        ticket-link
        ${isActive && 'active'}
        ${expanded && 'expanded'}
        ${mobile && 'dropdown-item'}
        ${minimized && 'minimized'}
        ${ticketSelector && 'ticket-selector'}
      `}
    >
      {layout}
    </TicketLink>
  ) : (
    <Tab
      className={`
        ${isActive && 'active'}
        ${expanded && 'expanded'}
        ${mobile && 'dropdown-item'}
        ${minimized && 'minimized'}
        ${ticketSelector && 'ticket-selector'}
      `}
      abbr={cityAbbreviation.replace(/\s+/g, '')}
      onClick={select}
      background={background}
    >
      {layout}
    </Tab>
  );
};

export default CityTab;



// WEBPACK FOOTER //
// ./src/components/city-selector/components/city-tab.js